/* eslint-disable no-underscore-dangle */

import queryString from 'query-string'
import log from '@/utils/log'

const baseUrl = 'https://sb.scorecardresearch.com/b'
const baseName = 'labs.op3.longread.2018.12'

const defaultParameters = {
  c1: '2',
  c2: '17827132',
  potag1: 'nosop3',
  potag2: 'nosop3',
  potag3: 'nos',
  potag4: 'nos',
  potag5: 'programma',
  potag6: 'video',
  potag7: 'npo3',
  potag8: 'site',
  potag9: 'site',
  nos_project: 'nos-labs',
  nos_event: 'pakjes',
  ns_site: 'po-totaal'
}

export default function track (parameters) {
  const fullParameters = Object.assign({}, defaultParameters, parameters)

  if (process.env.NODE_ENV === 'development') {
    log('[TRACKING]', fullParameters.name, fullParameters) // eslint-disable-line no-console
  }

  const url = `${baseUrl}?${queryString.stringify(fullParameters)}`
  window.udm_(url)
}

export function trackChapter (chapter) {
  track({
    name: `${baseName}.${chapter}`,
    nos_title: chapter,
    nos_labs_section: chapter
  })
}

export function trackVideo (video) {
  track({
    name: `${baseName}.video.play`,
    nos_title: video,
    ns_type: 'hidden'
  })
}

export function trackIntroOpen () {
  track({
    name: `${baseName}.introbox.open`,
    nos_title: 'intro',
    ns_type: 'hidden'
  })
}

export function trackIntroPick () {
  track({
    name: `${baseName}.introbox.picksize`,
    nos_title: 'intro',
    ns_type: 'hidden'
  })
}

export function trackIntroAway () {
  track({
    name: `${baseName}.introbox.away`,
    nos_title: 'intro',
    ns_type: 'hidden'
  })
}

export function trackOrders (amount) {
  track({
    name: `${baseName}.ordersreturns.orders`,
    nos_title: 'chapter-1-bestel-maar',
    nos_amount: amount,
    ns_type: 'hidden'
  })
}

export function trackReturns (amount) {
  track({
    name: `${baseName}.ordersreturns.returns`,
    nos_title: 'chapter-1-bestel-maar',
    nos_amount: amount,
    ns_type: 'hidden'
  })
}

export function trackAccordion (chapter) {
  track({
    name: `${baseName}.accordion`,
    nos_title: chapter,
    ns_type: 'hidden'
  })
}

export function trackCalculate (grams) {
  track({
    name: `${baseName}.co2calculate`,
    nos_title: 'chapter-4-de-smet-op-jouw-pakket',
    nos_amount: grams,
    ns_type: 'hidden'
  })
}

export function trackAir () {
  track({
    name: `${baseName}.air`,
    nos_title: 'chapter-4-de-smet-op-jouw-pakket',
    ns_type: 'hidden'
  })
}

export function trackFeedback (option) {
  track({
    name: `${baseName}.feedback`,
    nos_feedback: option,
    ns_type: 'hidden'
  })
}

export function trackSocial (platform) {
  track({
    name: `${baseName}.social`,
    nos_title: platform,
    ns_type: 'hidden',
    nos_labs_section: 'social'
  })
}
